import { apiFetch } from "../../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    if (typeof data.errors === "string")
        return data.errors;
    if (data.errors && typeof data.errors === "object") {
        return Object.values(data.errors).join(", ");
    }
    return data.detail || data.error || data.message || fallback;
};
export async function getTravelPlans(params) {
    const { baseUrl, statusId = 1, token } = params;
    const query = statusId !== undefined && statusId !== null ? `?status=${statusId}` : "";
    const data = await apiFetch(`/travel/api/get_travel_plan/${query}`, {
        baseUrl,
        token,
        method: "GET"
    });
    if (data.success === false) {
        throw new Error(getErrorMessage(data, "Failed to load travel plans"));
    }
    return data;
}
export async function deleteTravelPlan(params) {
    const { baseUrl, travelPlanId, token, csrfToken } = params;
    const data = await apiFetch(`/travel/api/delete_travel_plan/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined
    });
    if (data.success === false) {
        throw new Error(getErrorMessage(data, "Failed to delete travel plan"));
    }
    return data;
}
